import FormHandler from "./ahx-wcpl-ajax-form.js";

export default class AddToListNoSearchHandler extends FormHandler {
    constructor(formElement) {
        super(formElement);
        this.product_id              = this.formElement.dataset.product_id;
        this.variationsForm          = this.formElement.querySelector('.variations_form');
        if ( this.variationsForm ) {
            this.variations              = JSON.parse( this.variationsForm.dataset.product_variations );
            this.handleAttributeSelected = this.handleAttributeSelected.bind(this);
        }
        this.bindEvents();
    }

    bindEvents() {

        let _this = this;
        if( this.variationsForm ) {
            let attributeSelect = document.querySelectorAll('.variations select');
            if ( attributeSelect ) {
                attributeSelect.forEach(select => {
                    select.addEventListener('change', this.handleAttributeSelected );
                });
            }
        }

        if ( this.modal ) {
            this.modalDiv.addEventListener('show.bs.modal', function (event) {
                _this.maybeSyncForm();
            });
            this.modalDiv.addEventListener('hidden.bs.modal', function (event) {
                _this.resetForm();
            });
        }

    }

    resetForm() {

        this.formElement.querySelectorAll('select').forEach( select => {
            select.value = '';
        });
        this.formElement.querySelector('input[name="quantity"]').value = 1;

    }

    maybeSyncForm() {

        var cartForms = document.querySelectorAll('form.cart.variations_form');
        if ( cartForms ) {
            cartForms.forEach( form => {
                var product_id = form.dataset.product_id;
                if ( product_id === this.product_id ) {
                    // Select the same attributes in the list form as in the cart form
                    let attributeSelect = form.querySelectorAll('.variations select');
                    if ( attributeSelect ) {
                        attributeSelect.forEach(select => {
                            var attribute_name = select.getAttribute( 'name' );
                            this.variationsForm.querySelector('select[name="'+attribute_name+'"]').value = select.value;
                        });
                    }
                    // Sync the quantity
                    let quantityInput = form.querySelector('input[name="quantity"]');
                    if ( quantityInput ) {
                        this.formElement.querySelector('input[name="quantity"]').value = quantityInput.value;
                    }
                }
            });
        }

    }



    // Need to set the variation_id in the form when an attribute is selected
    handleAttributeSelected( event ) {

        var select = event.target;

        var form = select.closest('form');
        if ( form.dataset.product_id !== this.product_id ) {
            // console.log('form does not match product id');
            return;
        }

        var attributes = [];
        var attributeSelect = select.closest('.variations').querySelectorAll('select');
        for ( var i = 0; i < attributeSelect.length; i++ ) {
            var attribute = attributeSelect[i];
            var attribute_name = attribute.getAttribute( 'name' );
            attributes[ attribute_name ] = attribute.value;
        }
        var matching = [];
		for ( var i = 0; i < this.variations.length; i++ ) {
			var variation = this.variations[i];
			if ( this.isMatch( variation.attributes, attributes ) ) {
				matching.push( variation );
			}
		}
        if ( matching.length === 1 ) {
            var variation = matching[0];
            this.formElement.querySelector('input[name="variation_id"]').value = variation.variation_id;
        }

    }

    isMatch( variation_attributes, attributes ) {

        var match = true;
		for ( var attr_name in variation_attributes ) {
			if ( variation_attributes.hasOwnProperty( attr_name ) ) {
				var val1 = variation_attributes[ attr_name ];
				var val2 = attributes[ attr_name ];
				if ( val1 !== undefined && val2 !== undefined && val1.length !== 0 && val2.length !== 0 && val1 !== val2 ) {
					match = false;
				}
			}
		}
		return match;

    };

    async submitForm(event) {

        event.preventDefault();
        try {
            let result = await super.submitForm(event);

            if (result?.error) {
                this.showNotificationModal(
                    "Error Adding Product",
                    `<p>${result.error}</p><p>${result.message}</p>`
                );

                return;
            }

            if (result?.message)
                this.showNotificationModal(
                    "Product Added",
                    `<p>${result.message}</p>`
                );
        } catch (error) {
            console.log(error);
        }
    }
}
